import { useState, useEffect } from 'react';
import { crmAPI } from '../utils/api';

export const useCRM = () => {
  const [crmSettings, setCrmSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCRMSettings = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await crmAPI.getSettings();
      setCrmSettings(response.data);
    } catch (error) {
      if (error.response?.status !== 404) {
        setError(error.response?.data?.message || 'Failed to fetch CRM settings');
      }
      setCrmSettings(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCRMSettings();
  }, []);

  const isCRMActive = () => {
    return crmSettings?.isActive && crmSettings?.connectionStatus === 'connected';
  };

  const getCRMProvider = () => {
    return crmSettings?.crmProvider;
  };

  const refreshSettings = () => {
    fetchCRMSettings();
  };

  return {
    crmSettings,
    loading,
    error,
    isCRMActive,
    getCRMProvider,
    refreshSettings,
  };
};
